import Image from 'next/image';

import { maskAddressValue } from '@/utils/format';

import { EventTriggerType, Trigger } from '../../domain';
import { TriggerExternalLinkDetail } from './components/TriggerExternalLinkDetail';
import { TriggerType } from './components/TriggerType';

type Props = {
  trigger: Trigger;
  triggerType: EventTriggerType;
};

export const StellarTokenHoldersTriggerDetails = ({ trigger, triggerType }: Props) => {
  const tokenAddress = trigger.context?.token_address ?? '';
  const stellarExplorerUrl = `https://stellar.expert/explorer/public/contract/${tokenAddress}`;

  return (
    <div className="tw:flex tw:flex-row tw:gap-6">
      <TriggerType eventType={triggerType} />

      <TriggerExternalLinkDetail
        label="Contract"
        value={
          <div className="tw:flex tw:flex-row tw:gap-1 tw:items-center">
            <Image src="/assets/webp/stellar.webp" width={12} height={12} alt="Stellar" />
            <span>{maskAddressValue(tokenAddress)}</span>
          </div>
        }
        href={stellarExplorerUrl}
      />
    </div>
  );
};
